import { apiProxyRequest } from "Api/apiProxyRequest";

import type { AddCertificateRequest } from "./types";
import type { Project } from "@packages/client";

export const addCertificateRequest = ({
  project,
  certificate,
  chain,
  key
}: {
  project: Project;
  certificate: string;
  chain: string[];
  key: string;
}) =>
  apiProxyRequest<AddCertificateRequest>(
    project._links?.["#certificates"].href!,
    "POST",
    { certificate, chain, key }
  );
